import React, { useCallback, useReducer, useState } from "react"
import { obterExtratoPagarme } from "../../../services/extratoPagarmeFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ExtratoPagarmeFornecedorInicial } from "../models/extratoPagarmeFornecedorModel"
import { ExtratoPagarmeFornecedorActionsTypes } from "./extratoPagarmeFornecedorActions"
import { ExtratoPagarmeFornecedorContext } from "./ExtratoPagarmeFornecedorContext"
import { extratoPagarmeFornecedorReducer } from "./extratoPagarmeFornecedorReducer"

export function ExtratoPagarmeFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(extratoPagarmeFornecedorReducer, ExtratoPagarmeFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregarExtrato = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterExtratoPagarme(autorizacao, dados.dataInicio, dados.dataFim)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar extrato")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ExtratoPagarmeFornecedorActionsTypes.CARREGAR,
                    payload: {
                        transacoes: response.transacoes,
                        saldo: response.saldo,
                    },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar extrato")
        } finally {
            setLoading(false)
        }
    }, [dados.dataInicio, dados.dataFim, setLoading])

    return (
        <ExtratoPagarmeFornecedorContext.Provider
            value={{ dados, dispatch, erroCarregamento, carregarExtrato }}
        >
            <Loading />
            {children}
        </ExtratoPagarmeFornecedorContext.Provider>
    )
}
